// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";
import table from "./Table";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import {
    getRequestGroup,
    newRequestGroup,
    newSubRequestGroup,
    updateRequestGroup,
    updateSubRequestGroup,
} from "../../api/routes";
import { useState } from "react";
import { FormControl, InputLabel, MenuItem, Modal, Select } from "@mui/material";
import { useEffect } from "react";
import useStyle from "./style";
import queryString from "../../components/queryString";
import { toast } from "react-toastify";

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
};

function Requests() {
    const {
        columns,
        rows,
        isGroupOpen,
        isSubGroupOpen,
        groupClickedInfo,
        subGroupClickedInfo,
        subColumns,
        subRows,
    } = table();
    const classes = useStyle();
    const [groupOpen, setGroupOpen] = useState(false);
    const [subGroupOpen, setSubGroupOpen] = useState(false);
    const handleCloseGroup = () => setGroupOpen(false);
    const handleCloseSubGroup = () => setSubGroupOpen(false);
    const [information, setInformation] = useState({});
    const [updateInformation, setUpdateInformation] = useState({});
    const handleChange = (event) => {
        const { name, value } = event.target;
        setInformation({ ...information, [name]: value });
    };
    const handleUpdateChange = (event) => {
        const { name, value } = event.target;
        setUpdateInformation({ ...updateInformation, [name]: value });
    };
    const [requestGroupData, setRequestGroupData] = useState([]);

    useEffect(() => {
        if (isGroupOpen) {
            setGroupOpen(true);
        }
    }, [isGroupOpen]);

    useEffect(() => {
        if (isSubGroupOpen) {
            setSubGroupOpen(true);
        }
    }, [isSubGroupOpen]);

    useEffect(() => {
        const query = {
            all: 1,
        };
        getRequestGroup((isOk, data) => {
            if (!isOk) return toast.error(data.message);
            else return setRequestGroupData(data);
        }, queryString(query));
    }, []);

    useEffect(() => {
        if (groupClickedInfo)
            setUpdateInformation({
                nameGroup: groupClickedInfo.nameGroup,
                shortNameGroup: groupClickedInfo.shortNameGroup,
                isNotebookRequestGroup: +groupClickedInfo.isNoteBook,
            });

    }, [groupClickedInfo]);

    useEffect(() => {
        if (subGroupClickedInfo) {
            setUpdateInformation({
                subNameGroup: subGroupClickedInfo.subNameGroup,
                shortSubNameGroup: subGroupClickedInfo.shortSubNameGroup,
                price: subGroupClickedInfo.price,
            });
        }
    }, [subGroupClickedInfo]);

    const newGroup = () => {
        const data = {
            nameGroup: information.nameGroup,
            shortNameGroup: information.shortNameGroup,
            isNoteBook: information.isNotebookRequestGroup,
        };
        if (information.nameGroup && information.shortNameGroup) {
            newRequestGroup(data, (isOk, data) => {
                if (!isOk) return toast.error(data.message);
                else return window.location.reload();
            });
        } else return toast.error("ابتدا مقادیر را پر کنید!!");

    };
    const updateGroup = () => {
        const data = {
            groupId: groupClickedInfo.requestGroupId,
            nameGroup: updateInformation.nameGroup,
            shortNameGroup: updateInformation.shortNameGroup,
            isNoteBook: updateInformation.isNotebookRequestGroup,
        };
        if (updateInformation.nameGroup || updateInformation.shortNameGroup) {
            updateRequestGroup(data, (isOk, data) => {
                if (!isOk) return toast.error(data.message);
                else return window.location.reload();
            });
        } else return toast.error("ابتدا مقادیر را پر کنید!!");
    };

    const updateSubGroup = () => {
        const data = {
            subRequestGroupId: subGroupClickedInfo.subRequestGroupId,
            subNameGroup: updateInformation.subNameGroup,
            shortSubNameGroup: updateInformation.shortSubNameGroup,
            price: updateInformation.price,
        };
        if (updateInformation.subNameGroup || updateInformation.shortSubNameGroup || updateInformation.price) {
            updateSubRequestGroup(data, (isOk, data) => {
                if (!isOk) return toast.error(data.message);
                else return window.location.reload();
            });
        } else return toast.error("ابتدا مقادیر را پر کنید!!");
    };
    const newSubGroup = () => {
        if (information.requestGroupId && information.subNameGroup && information.shortSubNameGroup && information.price) {
            const index = requestGroupData.findIndex((item) => item.requestGroupId === information.requestGroupId);
            const data = {
                requestGroupId: information.requestGroupId,
                subNameGroup: information.subNameGroup,
                shortSubNameGroup: `${requestGroupData[index].shortNameGroup} - ${information.shortSubNameGroup}`,
                price: information.price,
            };
            newSubRequestGroup(data, (isOk, data) => {
                if (!isOk) return toast.error(data.message);
                else return window.location.reload();
            });
        } else return toast.error("ابتدا مقادیر را پر کنید!!");
    };

    return (
        <>
            <DashboardLayout>
                <MDBox pt={2} mb={6}>
                    <Grid container spacing={6}>
                        <Grid item xs={12}>
                            <Card>
                                <MDBox
                                    mx={2}
                                    mt={-3}
                                    py={3}
                                    px={2}
                                    variant="gradient"
                                    bgColor="info"
                                    borderRadius="lg"
                                    coloredShadow="info"
                                    sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
                                >
                                    <MDTypography variant="h6" color="white">
                                        افزودن گروه و زیر گروه
                                    </MDTypography>
                                    <DashboardNavbar />
                                </MDBox>
                                <MDBox pt={4} pb={3} px={3}>
                                    <div style={{ display: "flex", flexWrap: "wrap" }}>
                                        <section className={classes.requestGroupParent}>
                                            <MDInput type="text" name={"nameGroup"} value={information.nameGroup}
                                                     onChange={handleChange}
                                                     label="نام گروه" fullWidth />
                                            <Grid container mt={1} columnSpacing={1}>
                                                <Grid item xs={6}>
                                                    <MDInput fullWidth type="text" name={"shortNameGroup"}
                                                             value={information.shortNameGroup}
                                                             onChange={handleChange}
                                                             label="اختصار گروه"
                                                    />
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <FormControl fullWidth>
                                                        <InputLabel>آیا جز دفتر نوبت دهی است؟</InputLabel>
                                                        <Select name={"isNotebookRequestGroup"}
                                                                value={information.isNotebookRequestGroup}
                                                                onChange={handleChange}
                                                                label="آیا جز دفتر نوبت دهی است؟"
                                                                sx={{ height: "44.3px" }}>
                                                            <MenuItem value={"0"}>خیر</MenuItem>
                                                            <MenuItem value={"1"}>بله</MenuItem>
                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                            </Grid>

                                            <MDBox mt={4} mb={1}>
                                                <MDButton onClick={newGroup} variant="gradient" color="info">
                                                    ثبت گروه
                                                </MDButton>
                                            </MDBox>
                                        </section>
                                        <hr className={classes.divider} />
                                        <section className={classes.requestGroupParent}>
                                            <FormControl fullWidth>
                                                <InputLabel>گروه</InputLabel>
                                                <Select name={"requestGroupId"} value={information.requestGroupId}
                                                        onChange={handleChange}
                                                        label="گروه"
                                                        sx={{ height: "44.3px" }}>
                                                    {requestGroupData.map((item) =>
                                                        <MenuItem key={item.requestGroupId}
                                                                  value={item.requestGroupId}>{item.nameGroup} {item.isNoteBook ? " ** دفتر نوبت دهی **" : ""}</MenuItem>,
                                                    )}
                                                </Select>
                                            </FormControl>
                                            <MDBox mt={1}>
                                                <MDInput type="text" name={"subNameGroup"}
                                                         value={information.subNameGroup}
                                                         onChange={handleChange}
                                                         label="نام زیر گروه"
                                                         fullWidth />
                                            </MDBox>
                                            <Grid container mt={1} columnSpacing={1}>
                                                <Grid item xs={6}>
                                                    <MDInput type="text" name={"shortSubNameGroup"}
                                                             value={information.shortSubNameGroup} fullWidth
                                                             onChange={handleChange}
                                                             label="اختصار زیر گروه"
                                                    />
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <MDInput type="text" name={"price"} value={information.price}
                                                             fullWidth
                                                             onChange={handleChange}
                                                             label="مبلغ پرداخت (تومان)" />
                                                </Grid>
                                            </Grid>
                                            <MDBox mt={4} mb={1}>
                                                <MDButton onClick={newSubGroup} variant="gradient" color="info">
                                                    ثبت زیر گروه
                                                </MDButton>
                                            </MDBox>
                                        </section>
                                    </div>
                                </MDBox>
                            </Card>
                        </Grid>
                        <Grid item xs={12}>
                            <Card>
                                <MDBox
                                    mx={2}
                                    mt={-3}
                                    py={3}
                                    px={2}
                                    variant="gradient"
                                    bgColor="info"
                                    borderRadius="lg"
                                    coloredShadow="info"
                                >
                                    <MDTypography variant="h6" color="white">
                                        گروه
                                    </MDTypography>
                                </MDBox>
                                <MDBox pt={3}>
                                    <DataTable
                                        table={{ columns, rows }}
                                        isSorted={false}
                                        entriesPerPage={false}
                                        showTotalEntries={false}
                                        noEndBorder
                                    />
                                </MDBox>
                            </Card>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} mt={6}>
                        <Card>
                            <MDBox
                                mx={2}
                                mt={-3}
                                py={3}
                                px={2}
                                variant="gradient"
                                bgColor="info"
                                borderRadius="lg"
                                coloredShadow="info"
                            >
                                <MDTypography variant="h6" color="white">
                                    زیر گروه
                                </MDTypography>
                            </MDBox>
                            <MDBox pt={3}>
                                {subRows.length > 0 &&
                                    <DataTable
                                        table={{ columns: subColumns, rows: subRows }}
                                        isSorted={false}
                                        entriesPerPage={false}
                                        showTotalEntries={false}
                                        noEndBorder
                                    />}
                            </MDBox>
                        </Card>
                    </Grid>
                </MDBox>
                <Footer />
            </DashboardLayout>
            <Modal
                open={groupOpen}
                onClose={handleCloseGroup}
            >
                <MDBox sx={style} pt={4} pb={3} px={3}>
                    <MDBox>
                        <MDInput type="text" name={"nameGroup"} value={updateInformation.nameGroup}
                                 onChange={handleUpdateChange}
                                 label="نام گروه" fullWidth />
                    </MDBox>
                    <MDBox mt={2}>
                        <MDInput type="text" name={"shortNameGroup"} value={updateInformation.shortNameGroup}
                                 onChange={handleUpdateChange} label="اختصار گروه"
                                 fullWidth />
                    </MDBox>
                    <MDBox mt={2}>
                        <FormControl fullWidth>
                            <InputLabel>آیا جز دفتر نوبت دهی است؟</InputLabel>
                            <Select name={"isNotebookRequestGroup"}
                                    value={updateInformation.isNotebookRequestGroup}
                                    onChange={handleUpdateChange}
                                    label="آیا جز دفتر نوبت دهی است؟"
                                    sx={{ height: "44.3px" }}>
                                <MenuItem value={"0"}>خیر</MenuItem>
                                <MenuItem value={"1"}>بله</MenuItem>
                            </Select>
                        </FormControl>
                    </MDBox>
                    <MDBox mt={4} mb={1}>
                        <MDButton onClick={updateGroup} variant="gradient" color="info" sx={{ width: "120px" }}>
                            ثبت
                        </MDButton>
                    </MDBox>
                </MDBox>
            </Modal>
            <Modal
                open={subGroupOpen}
                onClose={handleCloseSubGroup}
            >
                <MDBox sx={style} pt={4} pb={3} px={3}>
                    <MDBox>
                        <MDInput type="text" name={"subNameGroup"} value={updateInformation.subNameGroup}
                                 onChange={handleUpdateChange} label="نام زیرگروه"
                                 fullWidth />
                    </MDBox>
                    <MDBox mt={2}>
                        <MDInput type="text" name={"shortSubNameGroup"} value={updateInformation.shortSubNameGroup}
                                 onChange={handleUpdateChange}
                                 label="اختصار زیرگروه"
                                 fullWidth />
                    </MDBox>
                    <MDBox mt={2}>
                        <MDInput type="text" name={"price"} value={updateInformation.price}
                                 onChange={handleUpdateChange}
                                 label="مبلغ پرداخت (تومان)" fullWidth />
                    </MDBox>
                    <MDBox mt={4} mb={1}>
                        <MDButton onClick={updateSubGroup} variant="gradient" color="info" sx={{ width: "120px" }}>
                            ثبت
                        </MDButton>
                    </MDBox>
                </MDBox>
            </Modal>
        </>
    );
}

export default Requests;
